// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "currency.proto" (package "currency", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message currency.RateAutoUpdateSettings
 */
export interface RateAutoUpdateSettings {
    /**
     * @generated from protobuf field: string script = 1
     */
    script: string;
    /**
     * @generated from protobuf field: bool enabled = 2
     */
    enabled: boolean;
}
/**
 * @generated from protobuf message currency.Currency
 */
export interface Currency {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string symbol = 3
     */
    symbol: string;
    /**
     * @generated from protobuf field: uint32 decimal_points = 4
     */
    decimalPoints: number;
    /**
     * @generated from protobuf field: string auto_update_settings_script = 5
     */
    autoUpdateSettingsScript: string;
    /**
     * @generated from protobuf field: bool auto_update_settings_enabled = 6
     */
    autoUpdateSettingsEnabled: boolean;
    /**
     * @generated from protobuf field: string risk = 7
     */
    risk: string;
    /**
     * @generated from protobuf field: string type = 8
     */
    type: string;
    /**
     * @generated from protobuf field: string rate_fetch_failed_at = 9
     */
    rateFetchFailedAt: string;
    /**
     * @generated from protobuf field: string rate_fetch_error = 10
     */
    rateFetchError: string;
    /**
     * @generated from protobuf field: string created_at = 11
     */
    createdAt: string;
}
/**
 * @generated from protobuf message currency.GetAllCurrenciesRequest
 */
export interface GetAllCurrenciesRequest {
}
/**
 * @generated from protobuf message currency.GetAllCurrenciesResponse
 */
export interface GetAllCurrenciesResponse {
    /**
     * @generated from protobuf field: repeated currency.Currency currencies = 1
     */
    currencies: Currency[];
}
/**
 * @generated from protobuf message currency.CreateCurrencyRequest
 */
export interface CreateCurrencyRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string symbol = 2
     */
    symbol: string;
    /**
     * @generated from protobuf field: uint32 decimal_points = 3
     */
    decimalPoints: number;
    /**
     * @generated from protobuf field: string auto_update_settings_script = 4
     */
    autoUpdateSettingsScript: string;
    /**
     * @generated from protobuf field: bool auto_update_settings_enabled = 5
     */
    autoUpdateSettingsEnabled: boolean;
    /**
     * @generated from protobuf field: string risk = 6
     */
    risk: string;
    /**
     * @generated from protobuf field: string type = 7
     */
    type: string;
}
/**
 * @generated from protobuf message currency.CreateCurrencyResponse
 */
export interface CreateCurrencyResponse {
    /**
     * @generated from protobuf field: uint32 currencyId = 1
     */
    currencyId: number;
}
/**
 * @generated from protobuf message currency.UpdateCurrencyFields
 */
export interface UpdateCurrencyFields {
    /**
     * @generated from protobuf field: optional string name = 1
     */
    name?: string;
    /**
     * @generated from protobuf field: optional string symbol = 2
     */
    symbol?: string;
    /**
     * @generated from protobuf field: optional uint32 decimal_points = 3
     */
    decimalPoints?: number;
    /**
     * @generated from protobuf field: optional string auto_update_settings_script = 4
     */
    autoUpdateSettingsScript?: string;
    /**
     * @generated from protobuf field: optional bool auto_update_settings_enabled = 5
     */
    autoUpdateSettingsEnabled?: boolean;
    /**
     * @generated from protobuf field: optional string risk = 6
     */
    risk?: string;
    /**
     * @generated from protobuf field: optional string type = 7
     */
    type?: string;
}
/**
 * @generated from protobuf message currency.UpdateCurrencyRequest
 */
export interface UpdateCurrencyRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: currency.UpdateCurrencyFields fields = 2
     */
    fields?: UpdateCurrencyFields;
}
/**
 * @generated from protobuf message currency.UpdateCurrencyResponse
 */
export interface UpdateCurrencyResponse {
}
/**
 * @generated from protobuf message currency.SetDefaultCurrencyRequest
 */
export interface SetDefaultCurrencyRequest {
    /**
     * @generated from protobuf field: uint32 currency_id = 1
     */
    currencyId: number;
}
/**
 * @generated from protobuf message currency.SetDefaultCurrencyResponse
 */
export interface SetDefaultCurrencyResponse {
}
/**
 * @generated from protobuf message currency.DeleteCurrencyRequest
 */
export interface DeleteCurrencyRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: optional uint32 target_id = 2
     */
    targetId?: number;
}
/**
 * @generated from protobuf message currency.DeleteCurrencyResponse
 */
export interface DeleteCurrencyResponse {
    /**
     * @generated from protobuf field: uint32 migrated_transactions = 1
     */
    migratedTransactions: number;
    /**
     * @generated from protobuf field: uint32 deleted_transactions = 2
     */
    deletedTransactions: number;
    /**
     * @generated from protobuf field: uint32 moved_to_unconfirmed = 3
     */
    movedToUnconfirmed: number;
    /**
     * @generated from protobuf field: uint32 deleted_balances = 4
     */
    deletedBalances: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class RateAutoUpdateSettings$Type extends MessageType<RateAutoUpdateSettings> {
    constructor() {
        super("currency.RateAutoUpdateSettings", [
            { no: 1, name: "script", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RateAutoUpdateSettings>): RateAutoUpdateSettings {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.script = "";
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial<RateAutoUpdateSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RateAutoUpdateSettings): RateAutoUpdateSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string script */ 1:
                    message.script = reader.string();
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RateAutoUpdateSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string script = 1; */
        if (message.script !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.script);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.RateAutoUpdateSettings
 */
export const RateAutoUpdateSettings = new RateAutoUpdateSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Currency$Type extends MessageType<Currency> {
    constructor() {
        super("currency.Currency", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "symbol", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "decimal_points", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "auto_update_settings_script", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "auto_update_settings_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "risk", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "rate_fetch_failed_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "rate_fetch_error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Currency>): Currency {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.name = "";
        message.symbol = "";
        message.decimalPoints = 0;
        message.autoUpdateSettingsScript = "";
        message.autoUpdateSettingsEnabled = false;
        message.risk = "";
        message.type = "";
        message.rateFetchFailedAt = "";
        message.rateFetchError = "";
        message.createdAt = "";
        if (value !== undefined)
            reflectionMergePartial<Currency>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Currency): Currency {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string symbol */ 3:
                    message.symbol = reader.string();
                    break;
                case /* uint32 decimal_points */ 4:
                    message.decimalPoints = reader.uint32();
                    break;
                case /* string auto_update_settings_script */ 5:
                    message.autoUpdateSettingsScript = reader.string();
                    break;
                case /* bool auto_update_settings_enabled */ 6:
                    message.autoUpdateSettingsEnabled = reader.bool();
                    break;
                case /* string risk */ 7:
                    message.risk = reader.string();
                    break;
                case /* string type */ 8:
                    message.type = reader.string();
                    break;
                case /* string rate_fetch_failed_at */ 9:
                    message.rateFetchFailedAt = reader.string();
                    break;
                case /* string rate_fetch_error */ 10:
                    message.rateFetchError = reader.string();
                    break;
                case /* string created_at */ 11:
                    message.createdAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Currency, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string symbol = 3; */
        if (message.symbol !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.symbol);
        /* uint32 decimal_points = 4; */
        if (message.decimalPoints !== 0)
            writer.tag(4, WireType.Varint).uint32(message.decimalPoints);
        /* string auto_update_settings_script = 5; */
        if (message.autoUpdateSettingsScript !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.autoUpdateSettingsScript);
        /* bool auto_update_settings_enabled = 6; */
        if (message.autoUpdateSettingsEnabled !== false)
            writer.tag(6, WireType.Varint).bool(message.autoUpdateSettingsEnabled);
        /* string risk = 7; */
        if (message.risk !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.risk);
        /* string type = 8; */
        if (message.type !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.type);
        /* string rate_fetch_failed_at = 9; */
        if (message.rateFetchFailedAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.rateFetchFailedAt);
        /* string rate_fetch_error = 10; */
        if (message.rateFetchError !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.rateFetchError);
        /* string created_at = 11; */
        if (message.createdAt !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.Currency
 */
export const Currency = new Currency$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllCurrenciesRequest$Type extends MessageType<GetAllCurrenciesRequest> {
    constructor() {
        super("currency.GetAllCurrenciesRequest", []);
    }
    create(value?: PartialMessage<GetAllCurrenciesRequest>): GetAllCurrenciesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllCurrenciesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllCurrenciesRequest): GetAllCurrenciesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllCurrenciesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.GetAllCurrenciesRequest
 */
export const GetAllCurrenciesRequest = new GetAllCurrenciesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllCurrenciesResponse$Type extends MessageType<GetAllCurrenciesResponse> {
    constructor() {
        super("currency.GetAllCurrenciesResponse", [
            { no: 1, name: "currencies", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Currency }
        ]);
    }
    create(value?: PartialMessage<GetAllCurrenciesResponse>): GetAllCurrenciesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.currencies = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllCurrenciesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllCurrenciesResponse): GetAllCurrenciesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated currency.Currency currencies */ 1:
                    message.currencies.push(Currency.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllCurrenciesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated currency.Currency currencies = 1; */
        for (let i = 0; i < message.currencies.length; i++)
            Currency.internalBinaryWrite(message.currencies[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.GetAllCurrenciesResponse
 */
export const GetAllCurrenciesResponse = new GetAllCurrenciesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCurrencyRequest$Type extends MessageType<CreateCurrencyRequest> {
    constructor() {
        super("currency.CreateCurrencyRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "symbol", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "decimal_points", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "auto_update_settings_script", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "auto_update_settings_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "risk", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateCurrencyRequest>): CreateCurrencyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.symbol = "";
        message.decimalPoints = 0;
        message.autoUpdateSettingsScript = "";
        message.autoUpdateSettingsEnabled = false;
        message.risk = "";
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial<CreateCurrencyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCurrencyRequest): CreateCurrencyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string symbol */ 2:
                    message.symbol = reader.string();
                    break;
                case /* uint32 decimal_points */ 3:
                    message.decimalPoints = reader.uint32();
                    break;
                case /* string auto_update_settings_script */ 4:
                    message.autoUpdateSettingsScript = reader.string();
                    break;
                case /* bool auto_update_settings_enabled */ 5:
                    message.autoUpdateSettingsEnabled = reader.bool();
                    break;
                case /* string risk */ 6:
                    message.risk = reader.string();
                    break;
                case /* string type */ 7:
                    message.type = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCurrencyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string symbol = 2; */
        if (message.symbol !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.symbol);
        /* uint32 decimal_points = 3; */
        if (message.decimalPoints !== 0)
            writer.tag(3, WireType.Varint).uint32(message.decimalPoints);
        /* string auto_update_settings_script = 4; */
        if (message.autoUpdateSettingsScript !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.autoUpdateSettingsScript);
        /* bool auto_update_settings_enabled = 5; */
        if (message.autoUpdateSettingsEnabled !== false)
            writer.tag(5, WireType.Varint).bool(message.autoUpdateSettingsEnabled);
        /* string risk = 6; */
        if (message.risk !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.risk);
        /* string type = 7; */
        if (message.type !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.CreateCurrencyRequest
 */
export const CreateCurrencyRequest = new CreateCurrencyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCurrencyResponse$Type extends MessageType<CreateCurrencyResponse> {
    constructor() {
        super("currency.CreateCurrencyResponse", [
            { no: 1, name: "currencyId", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<CreateCurrencyResponse>): CreateCurrencyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.currencyId = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateCurrencyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateCurrencyResponse): CreateCurrencyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 currencyId */ 1:
                    message.currencyId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateCurrencyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 currencyId = 1; */
        if (message.currencyId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.currencyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.CreateCurrencyResponse
 */
export const CreateCurrencyResponse = new CreateCurrencyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCurrencyFields$Type extends MessageType<UpdateCurrencyFields> {
    constructor() {
        super("currency.UpdateCurrencyFields", [
            { no: 1, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "symbol", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "decimal_points", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "auto_update_settings_script", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "auto_update_settings_enabled", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "risk", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "type", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateCurrencyFields>): UpdateCurrencyFields {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCurrencyFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCurrencyFields): UpdateCurrencyFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string name */ 1:
                    message.name = reader.string();
                    break;
                case /* optional string symbol */ 2:
                    message.symbol = reader.string();
                    break;
                case /* optional uint32 decimal_points */ 3:
                    message.decimalPoints = reader.uint32();
                    break;
                case /* optional string auto_update_settings_script */ 4:
                    message.autoUpdateSettingsScript = reader.string();
                    break;
                case /* optional bool auto_update_settings_enabled */ 5:
                    message.autoUpdateSettingsEnabled = reader.bool();
                    break;
                case /* optional string risk */ 6:
                    message.risk = reader.string();
                    break;
                case /* optional string type */ 7:
                    message.type = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCurrencyFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string name = 1; */
        if (message.name !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* optional string symbol = 2; */
        if (message.symbol !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.symbol);
        /* optional uint32 decimal_points = 3; */
        if (message.decimalPoints !== undefined)
            writer.tag(3, WireType.Varint).uint32(message.decimalPoints);
        /* optional string auto_update_settings_script = 4; */
        if (message.autoUpdateSettingsScript !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.autoUpdateSettingsScript);
        /* optional bool auto_update_settings_enabled = 5; */
        if (message.autoUpdateSettingsEnabled !== undefined)
            writer.tag(5, WireType.Varint).bool(message.autoUpdateSettingsEnabled);
        /* optional string risk = 6; */
        if (message.risk !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.risk);
        /* optional string type = 7; */
        if (message.type !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.UpdateCurrencyFields
 */
export const UpdateCurrencyFields = new UpdateCurrencyFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCurrencyRequest$Type extends MessageType<UpdateCurrencyRequest> {
    constructor() {
        super("currency.UpdateCurrencyRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "fields", kind: "message", T: () => UpdateCurrencyFields }
        ]);
    }
    create(value?: PartialMessage<UpdateCurrencyRequest>): UpdateCurrencyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateCurrencyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCurrencyRequest): UpdateCurrencyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* currency.UpdateCurrencyFields fields */ 2:
                    message.fields = UpdateCurrencyFields.internalBinaryRead(reader, reader.uint32(), options, message.fields);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCurrencyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* currency.UpdateCurrencyFields fields = 2; */
        if (message.fields)
            UpdateCurrencyFields.internalBinaryWrite(message.fields, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.UpdateCurrencyRequest
 */
export const UpdateCurrencyRequest = new UpdateCurrencyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCurrencyResponse$Type extends MessageType<UpdateCurrencyResponse> {
    constructor() {
        super("currency.UpdateCurrencyResponse", []);
    }
    create(value?: PartialMessage<UpdateCurrencyResponse>): UpdateCurrencyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateCurrencyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateCurrencyResponse): UpdateCurrencyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateCurrencyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.UpdateCurrencyResponse
 */
export const UpdateCurrencyResponse = new UpdateCurrencyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDefaultCurrencyRequest$Type extends MessageType<SetDefaultCurrencyRequest> {
    constructor() {
        super("currency.SetDefaultCurrencyRequest", [
            { no: 1, name: "currency_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<SetDefaultCurrencyRequest>): SetDefaultCurrencyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.currencyId = 0;
        if (value !== undefined)
            reflectionMergePartial<SetDefaultCurrencyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetDefaultCurrencyRequest): SetDefaultCurrencyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 currency_id */ 1:
                    message.currencyId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetDefaultCurrencyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 currency_id = 1; */
        if (message.currencyId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.currencyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.SetDefaultCurrencyRequest
 */
export const SetDefaultCurrencyRequest = new SetDefaultCurrencyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDefaultCurrencyResponse$Type extends MessageType<SetDefaultCurrencyResponse> {
    constructor() {
        super("currency.SetDefaultCurrencyResponse", []);
    }
    create(value?: PartialMessage<SetDefaultCurrencyResponse>): SetDefaultCurrencyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetDefaultCurrencyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetDefaultCurrencyResponse): SetDefaultCurrencyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetDefaultCurrencyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.SetDefaultCurrencyResponse
 */
export const SetDefaultCurrencyResponse = new SetDefaultCurrencyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCurrencyRequest$Type extends MessageType<DeleteCurrencyRequest> {
    constructor() {
        super("currency.DeleteCurrencyRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "target_id", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteCurrencyRequest>): DeleteCurrencyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteCurrencyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteCurrencyRequest): DeleteCurrencyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* optional uint32 target_id */ 2:
                    message.targetId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteCurrencyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* optional uint32 target_id = 2; */
        if (message.targetId !== undefined)
            writer.tag(2, WireType.Varint).uint32(message.targetId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.DeleteCurrencyRequest
 */
export const DeleteCurrencyRequest = new DeleteCurrencyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCurrencyResponse$Type extends MessageType<DeleteCurrencyResponse> {
    constructor() {
        super("currency.DeleteCurrencyResponse", [
            { no: 1, name: "migrated_transactions", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "deleted_transactions", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "moved_to_unconfirmed", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "deleted_balances", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteCurrencyResponse>): DeleteCurrencyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.migratedTransactions = 0;
        message.deletedTransactions = 0;
        message.movedToUnconfirmed = 0;
        message.deletedBalances = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteCurrencyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteCurrencyResponse): DeleteCurrencyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 migrated_transactions */ 1:
                    message.migratedTransactions = reader.uint32();
                    break;
                case /* uint32 deleted_transactions */ 2:
                    message.deletedTransactions = reader.uint32();
                    break;
                case /* uint32 moved_to_unconfirmed */ 3:
                    message.movedToUnconfirmed = reader.uint32();
                    break;
                case /* uint32 deleted_balances */ 4:
                    message.deletedBalances = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteCurrencyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 migrated_transactions = 1; */
        if (message.migratedTransactions !== 0)
            writer.tag(1, WireType.Varint).uint32(message.migratedTransactions);
        /* uint32 deleted_transactions = 2; */
        if (message.deletedTransactions !== 0)
            writer.tag(2, WireType.Varint).uint32(message.deletedTransactions);
        /* uint32 moved_to_unconfirmed = 3; */
        if (message.movedToUnconfirmed !== 0)
            writer.tag(3, WireType.Varint).uint32(message.movedToUnconfirmed);
        /* uint32 deleted_balances = 4; */
        if (message.deletedBalances !== 0)
            writer.tag(4, WireType.Varint).uint32(message.deletedBalances);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message currency.DeleteCurrencyResponse
 */
export const DeleteCurrencyResponse = new DeleteCurrencyResponse$Type();
/**
 * @generated ServiceType for protobuf service currency.CurrencyService
 */
export const CurrencyService = new ServiceType("currency.CurrencyService", [
    { name: "GetAllCurrencies", options: {}, I: GetAllCurrenciesRequest, O: GetAllCurrenciesResponse },
    { name: "CreateCurrency", options: {}, I: CreateCurrencyRequest, O: CreateCurrencyResponse },
    { name: "UpdateCurrency", options: {}, I: UpdateCurrencyRequest, O: UpdateCurrencyResponse },
    { name: "SetDefaultCurrency", options: {}, I: SetDefaultCurrencyRequest, O: SetDefaultCurrencyResponse },
    { name: "DeleteCurrency", options: {}, I: DeleteCurrencyRequest, O: DeleteCurrencyResponse }
]);
